import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.string.includes.js";
import { THREE_LETTER_EU_COUNTRY_CODES } from "@faire/web/common/consts/THREE_LETTER_EU_COUNTRY_CODES";
import { countryToISO } from "../../../utils/countryToISO";
// @ts-prune-ignore-next
export var isEUCountry = function isEUCountry(country) {
  var countryIso = countryToISO(country);
  return Object.keys(THREE_LETTER_EU_COUNTRY_CODES).includes(countryIso);
};
// Check if the order is shipping internationally
export var shipInternational = function shipInternational(context) {
  var _context$shippingCont, _context$shippingCont2, _context$shippingCont3, _context$shippingCont4;
  var shipFromCountry = (_context$shippingCont = context.shippingContext) === null || _context$shippingCont === void 0 ? void 0 : (_context$shippingCont2 = _context$shippingCont.ship_from_address) === null || _context$shippingCont2 === void 0 ? void 0 : _context$shippingCont2.country;
  var shipToCountry = (_context$shippingCont3 = context.shippingContext) === null || _context$shippingCont3 === void 0 ? void 0 : (_context$shippingCont4 = _context$shippingCont3.ship_to_address) === null || _context$shippingCont4 === void 0 ? void 0 : _context$shippingCont4.country;
  if (!shipFromCountry || !shipToCountry) {
    return false;
  }
  var fromEU = isEUCountry(shipFromCountry);
  var toEU = isEUCountry(shipToCountry);
  if (fromEU && toEU) {
    return false;
  }
  return shipFromCountry !== shipToCountry;
};